module.exports = __webpack_public_path__ + "img/33-image-1@2x.cc9d8bc5.png";